import { FlowStepActionFunction } from '../flow-engine';
import history from '../../routing/BrowserHistory';
import { APIContextActions } from '../../api/APIContext';

export const action: FlowStepActionFunction = function (_apiActions: APIContextActions): void {
  history.replace('/success');
};
